export enum StatisticRefinementMode {
	ALL_MASTER_ACCOUNTS = 'ALL_MASTER_ACCOUNTS',
	CURRENT_MASTER_ACCOUNT = 'CURRENT_MASTER_ACCOUNT'
}